export type MenuColors = { fundo?: string | null; cartao?: string | null };

type Surface = 'escuro' | 'claro';

const DARK_TEXT = '#231A13';
const LIGHT_TEXT = '#FFFBF3';
const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;

const luminance = (hex: string): number => {
  const [r, g, b] = [1, 3, 5].map((start) => {
    const channel = parseInt(hex.slice(start, start + 2), 16) / 255;
    return channel <= 0.03928 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

const contrast = (a: string, b: string): number => {
  const [light, dark] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (light + 0.05) / (dark + 0.05);
};

// Superfície "escura" recebe texto claro: vale o texto com maior contraste sobre a cor
export const surfaceFor = (background: string): Surface =>
  contrast(background, LIGHT_TEXT) > contrast(background, DARK_TEXT) ? 'escuro' : 'claro';

const applyColor = (cssVariable: string, dataAttribute: string, color?: string | null) => {
  const root = document.documentElement;
  if (color && HEX_COLOR.test(color)) {
    root.style.setProperty(cssVariable, color);
    root.setAttribute(dataAttribute, surfaceFor(color));
  } else {
    root.style.removeProperty(cssVariable);
    root.removeAttribute(dataAttribute);
  }
};

// Aplica as cores da loja em toda a página; sem cor configurada, vale o padrão de index.css
export const applyMenuColors = (colors?: MenuColors | null) => {
  applyColor('--cor-fundo', 'data-fundo', colors?.fundo);
  applyColor('--cor-cartao', 'data-cartao', colors?.cartao);

  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) {
    themeColor.setAttribute('content', getComputedStyle(document.documentElement).getPropertyValue('--cor-fundo').trim());
  }
};
